module.exports = __webpack_public_path__ + "img/rat.e9a326a7.svg";